import { PHASES_LIST } from "@/assets/constants/selectsLists";
import type { IInspectionPhase } from "@/types/types";
import { create } from "zustand";

interface PhaseStore {
  currentPhase: null | number;
  phaseLabel: string;
  tasks: number;
  completed: number;
  phaseStartDate: string;
  allNa: boolean;
  // Actions
  setPhase: (phase: number) => void;
  setCurrentPhase: (phases: IInspectionPhase[]) => void;
  setTasks: (totalQuestions: number) => void;
  setCompleted: (completed: number) => void;
  clearPhaseStatus: () => void;
  setPhaseStartDate: (date: string) => void;
  setAllNa: (allNa: boolean) => void;
}

export const usePhase = create<PhaseStore>((set) => ({
  currentPhase: null,
  tasks: 0,
  completed: 0,
  phaseLabel: "",
  phaseStartDate: "",
  allNa: false,
  setPhase: (phase) =>
    set(() => ({
      currentPhase: phase,
    })),
  setPhaseStartDate: (date) =>
    set(() => ({
      phaseStartDate: date,
    })),
  setCurrentPhase: (phases: IInspectionPhase[]) => {
    const currentPhase = phases.find((phs) => phs.startDate && !phs.endDate);

    let phaseLabelTMP = "";
    if (currentPhase) {
      phaseLabelTMP =
        PHASES_LIST.find((it) => it.id === currentPhase.phaseId)?.name || "";
    }
    set({
      phaseStartDate: currentPhase ? (currentPhase.startDate as string) : "",
      phaseLabel: phaseLabelTMP,
      currentPhase: currentPhase ? currentPhase.phaseId : null,
    });
  },
  setTasks: (totalQuestions) =>
    set({
      tasks: totalQuestions,
    }),
  setCompleted: (completed) =>
    set(() => ({
      completed,
    })),
  clearPhaseStatus: () =>
    set({
      currentPhase: null,
      tasks: 0,
      completed: 0,
      phaseLabel: "",
      phaseStartDate: "",
    }),
  setAllNa: (allNa) =>
    set(() => ({
      allNa,
    })),
}));
